// src/services/AiSearchService.js
import { parsePathString } from '../../utils/insuranceSearchUtil';
import ApiService from '../base/BaseApiService';
import { trackEvent } from './TrackingService';

/**
 * 文書検索を実行する
 * @param {Object} searchRequest - 検索リクエストオブジェクト
 * @returns {Promise<Object>} - 検索結果
 */
export const searchInsurance = async (searchRequest) => {
  try {
    return await ApiService.post('/aisearch/search', searchRequest, { timeout: 60000 });
  } catch (error) {
    console.error('AI Search error:', error);
    throw error;
  }
};

export const searchHikiuke = async (searchRequest, queryId, companyInfos) => {
  try {
    let idCounter = 0;
    const response = await ApiService.post('/hikiuke/search', searchRequest, { timeout: 60000 });
    const hikiukeGrouped = (response.results || []).reduce((acc, item) => {
      const key = parsePathString(item.pdfUrl).company;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {})
    const hikiukeFormatted = [];
    for (const company in hikiukeGrouped) {
      hikiukeFormatted.push({
        company: company,
        nameKana: companyInfos.find(info => info.name === company)?.nameKana || company,
        results: hikiukeGrouped[company].map(item => ({ ...item, queryId, id: idCounter++ })) // 各結果にqueryIdを追加
      });
    }

    trackEvent({
      name: "InsuranceSearchResultHikiuke",
      properties: {
        queryId: queryId,
        resultJson: JSON.stringify(hikiukeFormatted)
      }
    }).catch(error => console.error('検索結果ログ送信エラー:', error));

    // 保険会社の読み仮名でソート
    return hikiukeFormatted.sort((a, b) => a.nameKana.localeCompare(b.nameKana, 'ja'));
  } catch (error) {
    console.error('AI Hikiuke Search error:', error);
    throw error;
  }
}

/**
 * 検索履歴を検索する
 * @param {Object} searchParams - 検索パラメータ
 * @returns {Promise<Object>} - 検索結果
 */
export const searchSearchHistory = async (searchParams) => {
  try {
    return await ApiService.post('/search_history/search', searchParams, { timeout: 60000 }); 
  } catch (error) {
    console.error('Search History Search error:', error);
    throw error;
  }
};

/**
 * 検索履歴のお気に入り状態を切り替える
 * @param {number} historyId - 検索履歴のID
 * @returns {Promise<Object>} - 更新結果
 */
export const toggleFavoriteSearchHistory = async (historyId) => {
  try {
    return await ApiService.post(`/search_history/favorite`, { id: historyId }, { timeout: 60000 });
  } catch (error) {
    console.error('Toggle Favorite Search History error:', error);
    throw error;
  }
};

/**
 * 検索履歴の復元可否を検証する
 * @param {number|string} historyId - 検索履歴のID
 * @returns {Promise<Object>} - 復元可否結果
 */
export const validateSearchHistoryRestore = async (historyId) => {
  try {
    return await ApiService.post('/search_history/validate_restore', { history_id: historyId }, { timeout: 60000 });
  } catch (error) {
    console.error('Validate Search History Restore error:', error);
    throw error;
  }
};

/**
 * 検索履歴IDから検索条件を取得する
 * @param {number|string} historyId - 検索履歴のID
 * @returns {Promise<Object>} - 検索履歴詳細
 */
export const getSearchHistoryById = async (historyId) => {
  try {
    return await ApiService.get(`/search_history/${historyId}`, { timeout: 60000 });
  } catch (error) {
    console.error('Get Search History Detail error:', error);
    throw error;
  }
};

export default {
  searchInsurance,
  searchHikiuke,
  searchSearchHistory,
  toggleFavoriteSearchHistory,
  validateSearchHistoryRestore,
  getSearchHistoryById,
};
